import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { PassportMark } from "./PassportMark";

export function Shell() {
  const { user, logout } = useAuth();
  const isAdmin = user?.role === "admin";

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="brand-block">
          <PassportMark className="passport-mark topbar-mark" />
          <div>
            <h1 className="brand-mark">Surgical Passport</h1>
            <p className="brand-lock">Patient · Procedure · Site</p>
          </div>
        </div>
        <nav className="nav" aria-label="Portal">
          <NavLink to="/main" className={({ isActive }) => `nav-btn${isActive ? " active" : ""}`}>
            Main
          </NavLink>
          <NavLink to="/board" className={({ isActive }) => `nav-btn${isActive ? " active" : ""}`}>
            Board
          </NavLink>
          <NavLink to="/timeline" className={({ isActive }) => `nav-btn${isActive ? " active" : ""}`}>
            Timeline
          </NavLink>
          {isAdmin && (
            <NavLink to="/people" className={({ isActive }) => `nav-btn${isActive ? " active" : ""}`}>
              People
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/settings" className={({ isActive }) => `nav-btn${isActive ? " active" : ""}`}>
              Settings
            </NavLink>
          )}
          <span className="nav-user" title={user?.email || undefined}>
            {user?.display_name}
            {user?.role ? ` · ${user.role}` : ""}
          </span>
          <button type="button" className="nav-btn logout" onClick={logout}>
            Log out
          </button>
        </nav>
      </header>
      <div className="wrap">
        <Outlet />
      </div>
    </div>
  );
}
